import { Language } from '@/../../shared/src/utils/teamNameMappings';

export function getUserLanguage(): Language {
  // Try to get language from various sources
  
  // 1. Check Telegram WebApp language
  if (typeof window !== 'undefined' && window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code) {
    const telegramLang = window.Telegram.WebApp.initDataUnsafe.user.language_code;
    if (telegramLang.startsWith('ru')) {
      return 'ru';
    }
  }

  // 2. Check browser language
  if (typeof navigator !== 'undefined') {
    const browserLang = navigator.language || (navigator as any).userLanguage;
    if (browserLang && browserLang.startsWith('ru')) {
      return 'ru';
    }
  }

  // 3. Check localStorage preference
  if (typeof localStorage !== 'undefined') {
    const savedLang = localStorage.getItem('pclash-language');
    if (savedLang === 'ru' || savedLang === 'en') {
      return savedLang as Language;
    }
  }

  // 4. Default to English
  return 'en';
}

export function setUserLanguage(language: Language): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('pclash-language', language);
  }
}